export const downloadJson = async ({
  data,
  filename,
}: {
  data: Record<string, unknown> | unknown[] | string | number | boolean | null
  filename: string
}): Promise<void> => {
  const href = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(data))}`
  const link = document.createElement('a')
  link.href = href
  link.download = `${filename}.json`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadPng = ({
  elementRef,
  title,
  padding = 0,
  frameColor = '#ffffff',
}: {
  elementRef: React.RefObject<SVGElement>
  title: string
  padding: number
  frameColor: string
}) => {
  if (!elementRef.current) return
  const clone = elementRef.current.cloneNode(true) as SVGElement
  clone.style.opacity = '1'
  const svgData = new XMLSerializer().serializeToString(clone)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const img = new Image()
  img.onload = () => {
    const frame = Number.isFinite(padding) ? Math.max(padding, 0) : 0
    canvas.width = img.width + frame * 2
    canvas.height = img.height + frame * 2

    if (!ctx) return

    ctx.fillStyle = frameColor
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(img, frame, frame)
    const pngFile = canvas.toDataURL('image/png')
    const downloadLink = document.createElement('a')
    downloadLink.download = `${title} QR Code`
    downloadLink.href = `${pngFile}`
    downloadLink.click()
  }
  img.src = `data:image/svg+xml;base64,${window.btoa(svgData)}`
}
